import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getPaymentMethods(params) {
        const response = await axios.get(API_URL + "/paymentmethods", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addPaymentMethod(paymentmethod) {
        paymentmethod.type = "paymentmethods"
        const newJson = dataFormatter.serialize({ stuff: paymentmethod })
        const response = await axios.post(API_URL + "/paymentmethods", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deletePaymentMethod(paymentmethodId) {
        await axios.delete(API_URL + "/paymentmethods/" + paymentmethodId, { headers: authHeader() });
    },

    async getPaymentMethod(paymentmethodId) {
        const response = await axios.get(API_URL + "/paymentmethods/" + paymentmethodId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editPaymentMethod(paymentmethod) {
        paymentmethod.type = "paymentmethods"
        const newJson = dataFormatter.serialize({ stuff: paymentmethod })
        const response = await axios.patch(API_URL + "/paymentmethods/" + paymentmethod.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




